<div class="div-svg" 
    [style.width]="width"
    [style.height]="height"
    [style.color]="color"
    [innerHTML]="svgFileName | safeHtml"></div>